import React, { Component } from "react";
import { Tabs } from "antd";
const { TabPane } = Tabs;
export default class TabList extends Component {
  callback = (params) => {};
  render() {
    let { list } = this.props
    return (
      <div
        style={{
          backgroundColor: "#ffffff",
          boxSizing: "border-box",
          padding: "15px",
        }}
      >
        <Tabs defaultActiveKey="1" onChange={this.callback}>
          {
            list
            .filter(el=> el.component)
            .map(el=>{
              return (
                <TabPane tab={el.TabPaneName||el.type} key={el.id} forceRender>
                  {el.component}
                </TabPane>
              )
            })
          }
        </Tabs>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./apps/pages/main/workbench/Factor/tablist/TabList.js